import React, { useState, useEffect } from 'react';
import { Popover, List, ListItem, ListItemText, ListItemIcon, Modal, Typography, Box, Button, IconButton } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import LoginModal from '../../../user/login';
import ProfileUnLogin from "../../../../Asset/icon/profileUnLogin.svg";
import PersonIcon from '@mui/icons-material/Person';
import HistoryIcon from '@mui/icons-material/History';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout, getUserDetail } from '../../../../redux/Auth/AuthSlice';
import { Link } from 'react-router-dom';
import { isTokenExpired } from '../../../../utils/token';
import { useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import InitialsAvatar from './InitialsAvatar'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#00305c',
        color: '#ffff',
        boxShadow: theme.shadows[10],
        fontSize: 14,
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#00305c',
    },
}));

const ProfileMenu = ({ isLoginModalOpen, handleOpenLoginModal, handleCloseLoginModal, switchToSignUp }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.AuthSlice.isAuthenticated);
    const token = useSelector((state) => state.AuthSlice.token);

    const [anchorEl, setAnchorEl] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
    const location = useLocation();
    const navigate = useNavigate(); // Use useNavigate for navigation
    const isHomePage = location.pathname === '/' || location.pathname === '#';
    const profileImageClassName = isAuthenticated && isHomePage ? 'profileUnLogin-svg profile-circle' :
        !isAuthenticated && isHomePage ? 'profileUnLogin-svg' :
            isAuthenticated && !isHomePage ? 'profileUnLogin-svg-a profile-circle-a' :
                'profileUnLogin-svg-a';

    const todos = useSelector((state) => state);


    useEffect(() => {
        dispatch(getUserDetail({ token: token }))
        if (token && isTokenExpired(token)) {
            dispatch(logout());
            setIsModalOpen(true); // Show modal on token expiry
        }

    }, [token, dispatch]);

    const handleProfileClick = (event) => {
        if (isAuthenticated) {
            setAnchorEl(event.currentTarget);
        } else {
            handleOpenLoginModal();
        }
    };

    const handleProfileMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        dispatch(logout());
        setAnchorEl(null);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        handleOpenLoginModal();
    };



    const handleNavigate = (component) => {
        const event = new CustomEvent('updateSelectedComponent', { detail: { selectedComponent: component } });
        window.dispatchEvent(event);
        navigate('/userinformation', { state: { selectedComponent: component } });
        handleProfileMenuClose();
    };

    const userImage = useSelector((state) => state.AuthSlice.user?.user_image || ProfileUnLogin);

    const renderProfileImage = () => {
        const user = todos?.AuthSlice?.user;

        if (isAuthenticated && user?.user_image) {
            return (
                <LightTooltip title={t("Profile")} arrow>
                    <img
                        draggable={false}
                        className={profileImageClassName}
                        src={user.user_image}
                        alt="Profile"
                        onClick={handleProfileClick}
                    />
                </LightTooltip>
            );
        } else if (isAuthenticated && user?.user_image === null) {
            const name = user?.firstname && user?.lastname ? `${user.firstname} ${user.lastname}` : '';
            const initials = name.trim().split(' ').map((n) => n[0]).join('').toUpperCase();
            return (
                <LightTooltip title={t("Profile")} arrow>
                    <InitialsAvatar initials={initials} onClick={handleProfileClick} classNameIcon={profileImageClassName} />
                </LightTooltip>
            );
        } else {
            return (
                <LightTooltip title={t("Profile")} arrow>
                    <img
                        draggable={false}
                        className={profileImageClassName}
                        src={ProfileUnLogin}
                        alt="Profile"
                        onClick={handleProfileClick}
                    />
                </LightTooltip>
            );
        }
    };



    return (
        <div>
            {renderProfileImage()}
            {/* <img
                draggable={false}
                className={profileImageClassName} // Conditional class application
                src={userImage}
                alt="Profile"
                onClick={handleProfileClick}
            /> */}
            <Popover
                id="menu"
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleProfileMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <List>
                    <ListItem button onClick={() => handleNavigate("personal")}>
                        <ListItemIcon>
                            <PersonIcon />
                        </ListItemIcon>
                        <ListItemText primary={t("Personal Information")} />
                    </ListItem>
                    <ListItem button onClick={() => handleNavigate("booking")}>
                        <ListItemIcon>
                            <HistoryIcon />
                        </ListItemIcon>
                        <ListItemText primary={t("Booking History")} />
                    </ListItem>
                    <ListItem button onClick={() => handleNavigate("review")}>
                        <ListItemIcon>
                            <ThumbUpIcon />
                        </ListItemIcon>
                        <ListItemText primary={t("Review(s)")} />
                    </ListItem>
                    <ListItem button onClick={() => handleNavigate("whitelist")}>
                        <ListItemIcon>
                            <FavoriteIcon />
                        </ListItemIcon>
                        <ListItemText primary={t("Whitelist(s)")} />
                    </ListItem>
                    <ListItem button onClick={handleLogout}>
                        <ListItemIcon>
                            <ExitToAppIcon />
                        </ListItemIcon>
                        <ListItemText primary={t("Logout")} />
                    </ListItem>
                </List>
            </Popover>

            <LoginModal
                open={isLoginModalOpen}
                onClose={handleCloseLoginModal}
                onSignUp={switchToSignUp}
            />

            <Modal
                open={isModalOpen}
                onClose={handleModalClose}
                aria-labelledby="timeout-modal-title"
                aria-describedby="timeout-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "calc(100% - 32px)", sm: 420 },
                        bgcolor: "#fff",
                        borderRadius: "16px",
                        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.18)",
                        px: { xs: 3, sm: 4 },
                        py: 4,
                        outline: "none",
                        textAlign: "center",
                    }}
                >
                    {/* Close Button */}
                    <IconButton
                        aria-label="close"
                        onClick={handleModalClose}
                        sx={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            width: 36,
                            height: 36,
                            color: "#94a3b8",
                            transition: "all 0.2s ease",
                            "&:hover": {
                                bgcolor: "#f1f5f9",
                                color: "#475569",
                            },
                        }}
                    >
                        <CloseIcon sx={{ fontSize: 22 }} />
                    </IconButton>

                    {/* Icon */}
                    <Box
                        sx={{
                            width: 64,
                            height: 64,
                            borderRadius: "50%",
                            bgcolor: "#eff6ff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mx: "auto",
                            mb: 2.5,
                        }}
                    >
                        <AccessTimeRoundedIcon
                            sx={{
                                fontSize: 36,
                                color: "#1976d2",
                            }}
                        />
                    </Box>

                    {/* Title */}
                    <Typography
                        id="timeout-modal-title"
                        component="h2"
                        sx={{
                            fontSize: "24px",
                            fontWeight: 700,
                            color: "#152b58",
                            lineHeight: 1.3,
                            mb: 1.2,
                        }}
                    >
                        {t("Session Expired")}
                    </Typography>

                    {/* Description */}
                    <Typography
                        id="timeout-modal-description"
                        sx={{
                            fontSize: "15px",
                            lineHeight: 1.7,
                            color: "#64748b",
                            maxWidth: 320,
                            mx: "auto",
                            mb: 3,
                        }}
                    >
                        {t("Your session has expired. Please log in again.")}
                    </Typography>

                    {/* Login Button */}
                    <Button
                        onClick={handleModalClose}
                        variant="contained"
                        disableElevation
                        sx={{
                            width: "100%",
                            maxWidth: 260,
                            height: 46,
                            borderRadius: "10px",
                            bgcolor: "#1976d2",
                            fontSize: "14px",
                            fontWeight: 600,
                            textTransform: "none",
                            letterSpacing: "0.2px",
                            boxShadow: "0 4px 12px rgba(25, 118, 210, 0.25)",
                            transition: "all 0.2s ease",

                            "&:hover": {
                                bgcolor: "#1565c0",
                                boxShadow: "0 6px 16px rgba(25, 118, 210, 0.32)",
                                transform: "translateY(-1px)",
                            },

                            "&:active": {
                                transform: "translateY(0)",
                            },
                        }}
                    >
                        {t("Login again")}
                    </Button>
                </Box>
            </Modal>
        </div>
    );
};

export default ProfileMenu;
